<template>
  <section>
    <template v-if="ecoventureTrips.length">
      <h3 class="fs-24 mb-8">
        Ecoventures
      </h3>
      
      <ul class="mb-8">
        <li v-for="(pg, index) in ecoventureTrips" :key="index">
          <responsive>
            <template #lgmd>
              <desktop-programme :pg="pg" />
              <hr class="separator-slim my-8" v-if="index !== (ecoventureTrips.length - 1)" />
            </template>

            <template #sm>
              <mobile-programme :pg="pg" />
            </template>
          </responsive>
        </li>
      </ul>
    </template>

    <template v-if="expeditionTrips.length">
      <hr class="separator-slim my-16" />

      <h3 class="fs-24 mb-8">
        Expeditions
      </h3>

      <ul>
        <li v-for="(pg, index) in expeditionTrips" :key="index">
          <responsive>
            <template #lgmd>
              <desktop-programme :pg="pg" />
              <hr class="separator-slim my-8" v-if="index !== (expeditionTrips.length - 1)" />
            </template>

            <template #sm>
              <mobile-programme :pg="pg" />
            </template>
          </responsive>
        </li>
      </ul>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import {
  ECOVENTURE_CATEGORIES
} from '../../helpers/constants'
import DesktopProgramme from './DesktopProgramme'
import MobileProgramme from './MobileProgramme'
import Responsive from '../core/Responsive'

export default {
  components: {
    DesktopProgramme,
    MobileProgramme,
    Responsive
  },
  computed: {
    ...mapState(['programmes']),
    ecoventureTrips () {
      return this.programmes.filter(pg => pg.category === ECOVENTURE_CATEGORIES.ECOVENTURE)
    },
    expeditionTrips () {
      return this.programmes.filter(pg => pg.category === ECOVENTURE_CATEGORIES.EXPEDITION)
    }
  }
}
</script>
